export const NOTE_TYPE_SIMPLE = false;
export const NOTE_TYPE_TIME = true;
